<h3 *ngIf="isNew" mat-dialog-title>Voeg kopbewerking toe</h3>
<h3 *ngIf="!isNew" mat-dialog-title>Wijzig kopbewerking</h3>
<hr />
<mat-dialog-content>
  <form mat-card-content [formGroup]="form">
    <div class="dialog-row">
      <label class="vt-form-label">Kopbewerkingtype *</label>
      <mat-form-field>
        <mat-select (selectionChange)="changeHeadWorkingType($event.value)" formControlName="headWorkingType">
          <mat-option *ngFor="let value of headWorkingTypes" [value]="value.key">{{ value.value }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <ng-container *ngIf="standard">
      <div class="dialog-row">
        <label class="vt-form-label">Dubbele bewerking *</label>
        <mat-form-field>
          <mat-select (selectionChange)="changeMultipleHeadWorkings($event.value)" formControlName="multipleHeadWorkings">
            <mat-option *ngFor="let value of actives" [value]="value.key">{{ value.value }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="dialog-row">
        <label class="vt-form-label">Kopbewerking 1 *</label>
        <div class="horizontal-stacked-fields">
          <div class="vt-form-field-sm">
            <label class="vt-form-label-sm">1:</label>
            <mat-form-field>
              <input matInput type="number" min="0" formControlName="headWorkingOne" />
            </mat-form-field>
          </div>
          <div class="vt-form-field-sm">
            <label class="vt-form-label-sm">2:</label>
            <mat-form-field>
              <input matInput type="number" min="0" formControlName="headWorkingTwo" />
            </mat-form-field>
          </div>
          <div class="vt-form-field-sm">
            <label class="vt-form-label-sm">4:</label>
            <mat-form-field>
              <input matInput type="number" min="0" formControlName="headWorkingFour" />
            </mat-form-field>
          </div>
        </div>
      </div>
      <ng-container *ngIf="showSecondHeadWorking">
        <div class="dialog-row">
          <label class="vt-form-label">Kopbewerking 2 *</label>
          <div class="horizontal-stacked-fields">
            <div class="vt-form-field-sm">
              <label class="vt-form-label-sm">1:</label>
              <mat-form-field>
                <input matInput type="number" min="0" formControlName="secondHeadWorkingOne" />
              </mat-form-field>
            </div>
            <div class="vt-form-field-sm">
              <label class="vt-form-label-sm">2:</label>
              <mat-form-field>
                <input matInput type="number" min="0" formControlName="secondHeadWorkingTwo" />
              </mat-form-field>
            </div>
            <div class="vt-form-field-sm">
              <label class="vt-form-label-sm">4:</label>
              <mat-form-field>
                <input matInput type="number" min="0" formControlName="secondHeadWorkingFour" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!standard">
      <div class="form-group">
        <label class="vt-form-label">Verstek graden</label>
        <mat-form-field>
          <input type="number" matInput placeholder="Verstek graden" min="1" max="89" formControlName="miterDegrees" />
        </mat-form-field>
      </div>
    </ng-container>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="cancel()">Annuleren</button>
  <button mat-flat-button *ngIf="isNew" color="accent" (click)="saveHeadworking()" [disabled]="!form.valid">Voeg toe</button>
  <button mat-flat-button *ngIf="!isNew" color="accent" (click)="saveHeadworking()" [disabled]="!form.valid">Wijzig</button>
   
</mat-dialog-actions>
